import { render, staticRenderFns } from "./SwapPanel.vue?vue&type=template&id=6ef80d5a&scoped=true"
import script from "./SwapPanel.vue?vue&type=script&lang=js"
export * from "./SwapPanel.vue?vue&type=script&lang=js"
import style0 from "./SwapPanel.vue?vue&type=style&index=0&id=6ef80d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef80d5a",
  null
  
)

export default component.exports